import React, { useState, useEffect } from 'react';
import { Box, Button, HStack, Text } from '@chakra-ui/react';

const DISMISS_KEY = 'pwa-install-dismissed';
const DISMISS_DAYS = 7;

export const InstallPrompt: React.FC = () => {
  const [deferredPrompt, setDeferredPrompt] = useState<any>(null);
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    const dismissed = localStorage.getItem(DISMISS_KEY);
    if (dismissed) {
      const until = parseInt(dismissed, 10);
      if (Date.now() < until) return;
    }

    const handler = (e: Event) => {
      e.preventDefault();
      setDeferredPrompt(e);
      setShowBanner(true);
    };

    window.addEventListener('beforeinstallprompt', handler);
    return () => window.removeEventListener('beforeinstallprompt', handler);
  }, []);

  const handleInstall = async () => {
    if (!deferredPrompt) return;
    deferredPrompt.prompt();
    const { outcome } = await deferredPrompt.userChoice;
    if (outcome === 'accepted') {
      setShowBanner(false);
      setDeferredPrompt(null);
    }
  };

  const handleDismiss = () => {
    setShowBanner(false);
    localStorage.setItem(DISMISS_KEY, String(Date.now() + DISMISS_DAYS * 24 * 60 * 60 * 1000));
  };

  if (!showBanner || !deferredPrompt) return null;

  return (
    <Box
      position="fixed"
      bottom={4}
      left="50%"
      transform="translateX(-50%)"
      zIndex={1000}
      bg="white"
      boxShadow="xl"
      borderRadius="lg"
      borderWidth={1}
      borderColor="blue.200"
      p={4}
      maxW={{ base: 'calc(100% - 2rem)', md: '400px' }}
    >
      <HStack justify="space-between" align="center" gap={3} flexWrap="wrap">
        <Text fontSize="sm" color="gray.700" flex={1} minW={0}>
          Install app on your phone for quick access
        </Text>
        <HStack gap={2} flexShrink={0}>
          <Button
            size="sm"
            bgGradient="to-r"
            gradientFrom="#273f96"
            gradientTo="#1369b3"
            color="white"
            onClick={handleInstall}
            _hover={{ opacity: 0.9 }}
          >
            Install
          </Button>
          <Button size="sm" variant="ghost" colorScheme="gray" onClick={handleDismiss}>
            Not now
          </Button>
        </HStack>
      </HStack>
    </Box>
  );
};
